import * as React from 'react'

const useInputSearch = ({
  ref,
  value,
  disabled,
  autoFocus,
  placeholder,
  onChange,
  onBlur,
  onFocus,
  onSearch,
}) => {
  const inputRef = React.useRef(null)
  const [active, setActive] = React.useState(Boolean(value))
  const [focused, setFocused] = React.useState(Boolean(autoFocus && !disabled))
  const [erease, setErease] = React.useState(false)
  const [text, setText] = React.useState(value || '')
  const EMPTY = 'EMPTY'

  React.useEffect(() => {
    if (!value && !autoFocus) {
      setActive(false)
    }
  }, [value, autoFocus])

  React.useEffect(() => {
    if ((value && !active) || placeholder) {
      setActive(true)
    }
  }, [value, placeholder, active])

  const setRef = refElement => {
    if (ref) {
      ref.current = refElement
    }

    inputRef.current = refElement
  }

  const setFocus = () => {
    setFocused(true)
    const currentRef = inputRef.current
    if (currentRef) {
      currentRef.focus()
    }
  }

  const handleOnChange = event => {
    setText(event.target.value)
    setErease(false)

    if (onChange) {
      onChange(event)
    }
  }

  const handleOnSearch = (event, inputText) => {
    if (disabled) {
      event.stopPropagation()
      return
    }

    if (inputText == EMPTY) {
      onSearch('')
    } else {
      onSearch(inputText || text)
      setErease(true)
    }
  }

  const handleOnBlur = event => {
    setFocused(false)

    if (!event.target.value) {
      setActive(false)
      handleOnSearch(null, EMPTY)
    }

    if (onBlur) {
      onBlur(event)
    }
  }

  const handleOnFocus = event => {
    setFocused(true)
    setActive(true)

    if (onFocus) {
      onFocus(event)
    }
  }

  const handleOnClick = event => {
    if (disabled) {
      event.stopPropagation()

      return
    }

    setFocus()
    setActive(true)
  }

  const handleOnKeyDown = event => {
    if (disabled) {
      event.stopPropagation()

      return
    }

    if (event.code === 'Enter') {
      handleOnSearch(null, event.target.value)
    }
  }

  const handleOnErase = event => {
    if (disabled) {
      event.stopPropagation()

      return
    }

    setText('')
    handleOnSearch(null, EMPTY)
    setErease(false)
  }

  return {
    active,
    focused,
    text,
    erease,
    setRef,
    handleOnBlur,
    handleOnFocus,
    handleOnClick,
    handleOnChange,
    handleOnSearch,
    handleOnKeyDown,
    handleOnErase,
  }
}

export { useInputSearch }
